import DanceWorks from '../../pages/dance-works/DanceWorks'

import PrefixEnum from '../prefixes'

export default Object.freeze([
    { path: PrefixEnum.DANCE_WORKS, component: DanceWorks },
])
